import { render, staticRenderFns } from "./StockLedger.vue?vue&type=template&id=49de9fe6"
import script from "./StockLedger.vue?vue&type=script&lang=js"
export * from "./StockLedger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports